import React from "react";
import BaseButton from "./BaseButton";
import { Icon } from '@iconify/react';

const BaseCreate = (props) => (
  <BaseButton
    type="primary"
    icon={ <Icon icon="tabler:plus" width={ 18 } /> }
    { ...props }
  >
    { props.text || "Create" }
  </BaseButton>
);

export default BaseCreate;
